import React from 'react'

type Props = {
    className?: string
}


export default function Menu_IconAdd(props: Props) {
    return (
        <div className="icon i5-plus fs-10"/>
    )

}
